/**
 * Analytics client utilities — isomorphic (no server-only).
 * Called from client components (AnalyticsBeacon, HeatmapTracker, SiteSearch).
 */

/** Returns or creates an anonymous session ID stored in sessionStorage. */
export function getOrCreateSessionId(): string {
  if (typeof window === "undefined") return "";
  try {
    const key = "_ga_sid";
    let sid = sessionStorage.getItem(key);
    if (!sid) {
      sid = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
      sessionStorage.setItem(key, sid);
    }
    return sid;
  } catch {
    return "";
  }
}

/** Classify viewport width as device type. */
export function detectDevice(): "desktop" | "mobile" | "tablet" {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1100) return "tablet";
  return "desktop";
}

/** True when DNT is not set and analytics cookie was accepted. */
export function shouldTrack(analyticsConsent: boolean): boolean {
  if (!analyticsConsent) return false;
  if (typeof navigator !== "undefined" && navigator.doNotTrack === "1") return false;
  return true;
}
